
import React, { Component } from "react";
import { MapContainer, TileLayer, Marker, Popup, MapConsumer } from 'react-leaflet';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-geosearch/dist/geosearch.css';
import 'leaflet/dist/leaflet.js';

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import iconPosition from './location_icon.png';
//import iconOffice from "./office_icon.png"
import iconOffice from "./cu_location_icon.png"

import $ from 'jquery';


let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [30, 46],
  iconAnchor: [17, 46],
  popupAnchor: [-1, -25]
});

L.Marker.prototype.options.icon = DefaultIcon;


let SearchIcon = L.icon({
  iconUrl: iconPosition,
  iconSize: [30, 30],
  iconAnchor: [10, 20]
});

let positionIcon = L.icon({
  iconUrl: iconPosition,
  shadowUrl: iconShadow,
  //iconSize: [48, 40],
  shadowAnchor: [7, 45],
  iconAnchor: [17, 46],
  popupAnchor: [8, -26]
});

let officeIcon = L.icon({
  iconUrl: iconOffice,
  shadowUrl: iconShadow,
  iconSize: [30, 35],
  iconAnchor: [17, 46],
  popupAnchor: [0, -30]
});

let img = `
<div class="location">
  <img class="img-location" src="./dist/img/location-cu.png" alt="cu">
 
</div>
`;

let htmlIcon = L.divIcon({
  className: 'custom-div-icon',
  html: img,
  //iconSize: [20, 32],
  iconSize: [30, 42],
  iconAnchor: [50, 60],
  popupAnchor: [0, -35]
});


const provider = new OpenStreetMapProvider({
  params: {
    countrycodes: "py"
  }
});

const searchControl = new GeoSearchControl({
  provider: provider,
  style: 'bar', // optional: bar|button  - default button
  autoComplete: true,  // opcional: true | false - default true 
  marker: {
    // optional: L.Marker    - default L.Icon.Default
    icon: SearchIcon,
    draggable: false,
  },
  autoCompleteDelay: 250,  // opcional: number - default 250 
  showMarker: true, // optional: true|false  - default true
  searchLabel: 'Ingrese calles o referencias(locales, negocios, plazas, iglesias, etc)',
});

var posicion = {
  latitud: 0,
  longitud: 0,
  marca: false
};

var posicionActual = {
  latitud: 0,
  longitud: 0,
  marca: true
}

var newMarker = null;
var mapa;
var refMarkerBD;


export default class Mapa extends Component {

  constructor(props) {
    super(props);
    refMarkerBD = React.createRef();
    this.moverCamara = this.moverCamara.bind(this);
    this.actualizarPosicion = this.actualizarPosicion.bind(this);
    this.marcarUbicacionActual = this.marcarUbicacionActual.bind(this);
    this.borrarMarcadores = this.borrarMarcadores.bind(this);
    this.activarPopup = this.activarPopup.bind(this);
  }

  componentDidMount() {
    //this.obtenerUbicacionBD();
  }

  mostrarSucursalesCercanas() {

    if (mapa) {

      this.borrarMarcadores();

      this.props.sucursales.forEach(sucursal => {

        let lat, lng = 0;

        lat = parseFloat(sucursal.latitud);
        lng = parseFloat(sucursal.longitud);

        //// agrega la ubicacion nueva seleccionada
        newMarker = new L.marker([lat, lng], { icon: htmlIcon, draggable: false })
          .on("click", (e) => {
            //mapa.flyTo(e.latlng);
            this.moverCamara(e.latlng, 14);
            this.props.clickPopup(sucursal);
          })
          .addTo(mapa)
          .bindPopup(`<b>${sucursal.nombreSucursal}</b>`);

      });

    }

  }

  //// muestra en el mapa el marcador obtenido desde la base de datos
  locationMarker() {
    const position = [posicion.latitud, posicion.longitud];
    return posicion.marca === false ? null : (
      <Marker
        position={position}
        ref={refMarkerBD}>
        <Popup>
          <b>{this.props.departamento} - {this.props.barrio}</b>  <br />
          {this.props.direccion}
        </Popup>
      </Marker>
    )
  }

  posicionActualMarker() {
    const position = [posicionActual.latitud, posicionActual.longitud];
    return posicionActual.marca === false ? null : (
      <Marker
        position={position}
        ref={refMarkerBD}
        icon={positionIcon}
        draggable={false}
      >
        <Popup>
          <b>Mi ubicación actual</b>
        </Popup>
      </Marker>
    )
  }

  moverCamara(coordenadas, zoom) {
    mapa.flyTo(coordenadas, zoom, { animate: false });
  }

  actualizarPosicion() {

    $("div[name=card-sucursal]").removeClass("text-white bg-success");
    $("div[name=card-sucursal] [name=btn-gps]").removeClass("btn-cu-secundary");
    $("div[name=card-sucursal] [name=btn-gps]").addClass("btn-cu-primary");

    this.marcarUbicacionActual();

    this.props.actualizarPosicion();
  }

  borrarMarcadores() {
    mapa.eachLayer((layer) => {
      if (layer._latlng) {
        mapa.removeLayer(layer);
      }
    });
  }

  activarPopup({ latitud, longitud }) {
    mapa.eachLayer((layer) => {
      if (layer._latlng && layer._latlng.lat === latitud && layer._latlng.lng === longitud) {
        layer.togglePopup();
      }
    });
  }

  marcarUbicacionActual() {
    //// agrega la ubicacion nueva seleccionada
    newMarker = new L.marker(this.props.posicionActual, { icon: positionIcon, draggable: false })
      .addTo(mapa)
      .bindPopup(`<b>Mi Ubicación Actual</b>`);
    this.moverCamara(this.props.posicionActual, 14);
  }


  render() {

    return (

      <MapContainer
        doubleClickZoom={true}
        center={this.props.posicionActual}
        zoom={13}
        scrollWheelZoom={false}
        className="map-sucursal"
      >

        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <MapConsumer>
          {(map) => {
            mapa = map;
            map.addControl(searchControl);
            this.mostrarSucursalesCercanas();
            this.marcarUbicacionActual();
            return null;
          }}
        </MapConsumer>

        <div className="leaflet-control-container">
          <div className="leaflet-right leaflet-bottom">
            <div className="leaflet-bar leaflet-control">
              <button title="Ubicación Actual" type="button" id="btn_gps"
                onClick={this.actualizarPosicion}
              >
                <i className="fas fa-street-view" style={{ fontSize: "large" }}></i>
              </button>
            </div>
          </div>
        </div>

      </MapContainer >
    )
  }

}